import Skeleton from "react-loading-skeleton";

import { TableData } from "~/common/components";

interface LoadingPatientsTableProps {
  length?: number;
}

export const LoadingPatientsTable = ({
  length = 3,
}: LoadingPatientsTableProps) => {
  const array = Array.from({ length }, (_, index) => index + 1);
  return (
    <tbody className="text-[0.94rem] text-gray-700">
      {array.map((_, index) => (
        <tr key={index}>
          <TableData colSpan={5} className="border-gray-200">
            <Skeleton containerClassName="block my-0.5" />
          </TableData>
        </tr>
      ))}
    </tbody>
  );
};
